import type { ReferenceLetterLeaver } from '../../types/referenceLetterDraft';
import { WITH_SIGNATORY } from './signatureLabels';

/** The supervisor's request has the task notes AND every grade: a letter can be drafted. */
export const isComplete = (l: ReferenceLetterLeaver) => Boolean(l.request?.tasksSubmitted && l.request?.evaluationSubmitted);

/** Ready to draft: complete, and not already out for signature or signed. */
export const isReady = (l: ReferenceLetterLeaver) => isComplete(l) && !WITH_SIGNATORY.has(l.request?.signature ?? 'none');

/**
 * Consecutive leavers by month of their termination date, keeping the list's own order (newest
 * first). Read from the date's own digits: a YYYY-MM-DD is a calendar day, not a moment in time.
 */
export function groupByMonth(leavers: ReferenceLetterLeaver[]) {
  const groups: Array<{ key: string; label: string; leavers: ReferenceLetterLeaver[] }> = [];
  for (const l of leavers) {
    const key = l.terminationDate.slice(0, 7);
    if (groups.at(-1)?.key !== key) {
      const [y, m] = key.split('-').map(Number);
      const label = new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' });
      groups.push({ key, label, leavers: [] });
    }
    groups.at(-1)!.leavers.push(l);
  }
  return groups;
}
